import React from 'react'
import ResourceHeader from './ResourceHeader'
import ResourceCardList from './ResourceCardList'
import '../../styles/ResourceSection/ResourceSection.scss'

const ResourceSection = () => {
  return (
        <div className="resource_cards_wrapper">
            <ResourceHeader />
            <ResourceCardList />
        </div>
  )
}

export default ResourceSection
